import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);

  public getAzureADToken(code: string): Observable<any> {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    const url = `${environment.azureGetTokenBaseUrl
      .replace(':tenant', environment.tenant)
      .replace(':tenant', environment.tenant)
      .replace(':police', environment.azurePolicy)}/token`;

    return this.http.get(url, { headers, params: this.fillgetAzureADTokenParams(code) });
  }

  public isLoggedIn() {
    const isAuthenticated = localStorage.getItem('hubapi-web-user-credential');

    if (isAuthenticated) return true;

    return false;
  }

  private fillgetAzureADTokenParams(code: string) {
    const params = new HttpParams()
      .set('grant_type', 'authorization_code')
      .set('client_id', environment.azureClientId)
      .set('escope', 'openid profile admin')
      .set('code', code)
      .set('redirect_uri', window.origin)
      .set('code_challenge_method', 'SHA256')
      .set('code_challenge', environment.azureCodeChallenge)
      .set('client_secret', environment.azureClientSecret);

    return params;
  }
}
